import styled from 'styled-components';
import PropTypes from 'prop-types';

const ContainerBoxStyled = styled.div`
  border-radius: ${props => props.borderRadius};
  background: ${props => props.background};
  width: 100%;
  box-shadow: ${props => props.boxShadow};
  display: ${props => props.display};
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: ${props => props.margin};
  max-width: ${props => props.maxWidth};
  overflow: ${props => props.overflow};
  padding: ${props => props.padding};
  position: relative;
  gap: ${props => props.gap};
  @media screen and (min-width: 769px) {
    padding: ${props => props.desktopPadding || props.padding};
  }
`;

ContainerBoxStyled.propTypes = {
  background: PropTypes.string.isRequired,
  padding: PropTypes.string.isRequired,
  boxShadow: PropTypes.string.isRequired,
  display: PropTypes.string.isRequired,
  overflow: PropTypes.string.isRequired,
  margin: PropTypes.string.isRequired,
};

export default ContainerBoxStyled;
